export default __webpack_public_path__ + "static/media/AmericanDreamers_Splash_1.9a19dcdc.jpg";